import { App_Url_New } from "@/shared/common/static";

import type { ResumeTarget } from "../utils/resumeJourney";

const lifeGetQuoteStep = (stepIndex: number) =>
  `${App_Url_New.D2CPageUrl.insurance.lifeGetQuote}?step=${stepIndex}`;

export const LIFE_RESUME_STEP_TARGETS = {
  step_1_pre_request: {
    path: lifeGetQuoteStep(1),
    stepIndex: 1,
    stepLabel: "Personal Details",
  },
  step_2_pre_request: {
    path: lifeGetQuoteStep(2),
    stepIndex: 2,
    stepLabel: "Term Insurance Details",
  },
  quote_request: {
    path: lifeGetQuoteStep(3),
    stepIndex: 3,
    stepLabel: "Get Quote",
  },
  selected_quote: {
    path: lifeGetQuoteStep(3),
    stepIndex: 3,
    stepLabel: "Buy Now",
  },
  step_5_post_request: {
    path: lifeGetQuoteStep(4),
    stepIndex: 4,
    stepLabel: "Document Upload",
  },
  step_6_post_request: {
    path: lifeGetQuoteStep(5),
    stepIndex: 5,
    stepLabel: "Additional Details",
  },
  step_7_post_request: {
    path: lifeGetQuoteStep(5),
    stepIndex: 5,
    stepLabel: "Payment",
  },
  step_8_post_request: {
    path: App_Url_New.D2CPageUrl.insurance.lifePolicyResult,
    stepLabel: "Policy Issue",
  },
} satisfies Record<string, ResumeTarget>;

export const LIFE_RESUME_STEP_FALLBACK_ORDER = [
  "step_8_post_request",
  "step_7_post_request",
  "step_6_post_request",
  "step_5_post_request",
  "selected_quote",
  "quote_request",
  "step_2_pre_request",
  "step_1_pre_request",
] as const;

export type LifeResumeStepName = keyof typeof LIFE_RESUME_STEP_TARGETS;
